export const FragmentProductListingBox = new TypedDocumentString(`
    fragment ProductListingBox on ProductListingBox {
  id
  groupId
  sellerId
  sku
  color
  departmentName
  isNew
  slug
  title
  availabilityType
  availableAt
  quantityLimit
  privateVisibility
  _values {
    ...ProductListingValues
    __typename
  }
  option {
    key
    uiKey
    uiValue
    __typename
  }
  settingsQty {
    ...ProductSettingsQty
    __typename
  }
  rating {
    count
    rating
    __typename
  }
  imageCount
  images {
    ...ImageNodeItem
    __typename
  }
  img1
  returnsNotAllowed
  __typename
}
    fragment ProductPriceLineItem on ProductPriceLineItem {
  qty
  price {
    priceForHumans
    number
    __typename
  }
  ui {
    ...DiscountUi
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPrice on ProductListingBoxUiPrice {
  bulk {
    price
    qty
    __typename
  }
  endAt
  publicCode {
    code
    percent
    price {
      priceForHumans
      number
      __typename
    }
    __typename
  }
  price {
    priceForHumans
    number
    __typename
  }
  priceTaxless {
    priceForHumans
    number
    __typename
  }
  priceOld {
    priceForHumans
    number
    __typename
  }
  lineItems {
    ...ProductPriceLineItem
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPriceFull on ProductListingBoxUiPrice {
  ...ProductListingBoxUiPrice
  _limited {
    limit
    left
    leftPercent
    __typename
  }
  __typename
}
fragment ProductBoxImages on ListingBoxImages {
  id
  slug
  imageBox {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductSettingsQty on ProductSettingsQty {
  min
  max
  step
  unit
  stockMsg
  __typename
}
fragment ProductOptionsItem on ProductOptionsItem {
  key
  name
  guideProductId
  guideBodyId
  values {
    name
    hsla {
      ...DocumentColorHsla
      __typename
    }
    image {
      ...ImageNodeItem
      __typename
    }
    product {
      productId
      title
      inStock
      slug
      image {
        ...ImageNodeItem
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment ProductListingValues on ProductListingValues {
  variantCount
  variantAvailableCount
  variantBoxList {
    ...ProductBoxImages
    __typename
  }
  stock
  inStock
  options {
    ...ProductOptionsItem
    __typename
  }
  _uiPrice {
    ...ProductListingBoxUiPriceFull
    __typename
  }
  __typename
}
fragment DiscountUi on DiscountUi {
  msg
  amount
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}`, {"fragmentName":"ProductListingBox"});